import { PCN_PUT_VIDEO, VIDEO_ALL_TAB, VIDEO_MY_TAB } from '../../../constants/permission';
import { TT_EDITORIAL } from '../../../constants/routePath';
import {
  ACCESS_PRIVATE,
  ACCESS_PUBLIC,
  ACCESS_SITE,
  TYPE_ALL,
  TYPE_OWN,
  USER_ROLE_OWNER,
} from '../../../constants/video';

import { getUser, hasPermission } from '../../../helpers/user';

export const canUserShareVideo = (videoAccess) => {
  const videoOwnerId = videoAccess.users.find((u) => u.role === USER_ROLE_OWNER)?.id;

  return videoAccess.level === ACCESS_PRIVATE ? videoOwnerId === getUser().id : true;
};

export const canUserUnShareVideo = (videoAccess) => {
  const videoOwnerId = videoAccess.users.find((u) => u.role === USER_ROLE_OWNER)?.id ?? null;
  const isVideoOwner = videoOwnerId === getUser().id;

  return (
    (videoAccess.level === ACCESS_PRIVATE && isVideoOwner) || [ACCESS_PUBLIC, ACCESS_SITE].includes(videoAccess.level)
  );
};

export const canUserEditVideo = (video) => {
  const videoOwnerId = video.access.users.find((u) => u.role === USER_ROLE_OWNER)?.id;

  const ownContents = getUser()
    .contentOwners.filter((owner) => owner.publisherOwnsContent)
    .map((owner) => owner.contentOwnerId);

  const hasOwnAccess = (hasPermission(VIDEO_ALL_TAB) || hasPermission(VIDEO_MY_TAB)) && videoOwnerId === getUser().id;

  const hasAllAccess =
    hasPermission(VIDEO_ALL_TAB) &&
    hasPermission(PCN_PUT_VIDEO) &&
    [ACCESS_SITE, ACCESS_PUBLIC].includes(video.access.level) &&
    ownContents.includes(video.contentOwner);

  return hasOwnAccess || hasAllAccess;
};

export const getEditVideoLink = (video) => {
  if (!video) {
    return '';
  }

  const videoOwnerId = video.access.users.find((u) => u.role === USER_ROLE_OWNER)?.id;
  const videoType = videoOwnerId === getUser().id && hasPermission(VIDEO_MY_TAB) ? TYPE_OWN : TYPE_ALL;

  return `${TT_EDITORIAL}?videoTabs=${videoType}&videoId=${video.videoId}`;
};

export const canUserDownloadVideo = (videoAccess) => videoAccess.level === ACCESS_SITE;
